import { ProSidebar, Menu, MenuItem, SubMenu, SidebarHeader, SidebarFooter, SidebarContent } from 'react-pro-sidebar';
import HomeIcon from '@mui/icons-material/Home';
import LogoutIcon from '@mui/icons-material/Logout';
import Button from '@mui/material/Button';
import LoginIcon from '@mui/icons-material/Login';
import DynamicFormIcon from '@mui/icons-material/DynamicForm';
import PeopleIcon from '@mui/icons-material/People';
import SettingsIcon from '@mui/icons-material/Settings';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import ViewQuiltIcon from '@mui/icons-material/ViewQuilt';

import './SideBar.scss';
import { useContext, useEffect, useLayoutEffect, useState } from 'react';
import { useMsal, AuthenticatedTemplate, UnauthenticatedTemplate, useIsAuthenticated } from '@azure/msal-react';
import { Link } from 'react-router-dom';
import { DependencyInjectionContext } from "../../../contexts/dependency-injection-context";
import { Roles, User } from '../../../common/interfaces';

export const SideBar = (props: any) => {
    const responseBreakpoint = 768;
    const [isCollapsed, setIsCollapsed] = useState(false);
    const { instance } = useMsal();
    const { formsApi, applicationState } = useContext(DependencyInjectionContext);
    const [currentUser, setCurrentUser] = useState<User>();

    const [isFormAdmin, setIsFormAdmin] = useState(false);
    const [isUserAdmin, setIsUserAdmin] = useState(false);
    const [isFormSubmissionViewer, setIsFormSubmissionViewer] = useState(false);

    const isAuthenticated = useIsAuthenticated();

    useLayoutEffect(() => {
        function updateSize() {
            setIsCollapsed(window.innerWidth < responseBreakpoint);
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);

    useEffect(() => {
        const getCurrentUser = async () => {
            const user = await formsApi.get<User>('CurrentUser');
            setCurrentUser(user);

            setIsFormAdmin(user.roles.some(x => x === Roles.FormsAdmin));
            setIsUserAdmin(user.roles.some(x => x === Roles.UserAdmin));
            setIsFormSubmissionViewer(user.roles.some(x => x === Roles.FormSubmissionViewer));
        };
        if (isAuthenticated) {
            getCurrentUser();
        }
    }, [isAuthenticated]);

    return (
        <ProSidebar collapsed={isCollapsed} className='no-print'>
            <SidebarHeader>
            </SidebarHeader>
            <SidebarContent>
                <Menu popperArrow={true} iconShape="square">
                    <MenuItem icon={<HomeIcon />}><Link to="/">Home</Link></MenuItem>
                    <AuthenticatedTemplate>
                        {(isFormAdmin || isFormSubmissionViewer) &&
                            <SubMenu title="Forms" icon={<DynamicFormIcon />}>
                                {isFormAdmin &&
                                    <MenuItem><Link to="/forms/definitions">Form Definitions</Link></MenuItem>
                                }
                                {isFormSubmissionViewer &&
                                    <MenuItem><Link to="/forms/submissions">Form Submissions</Link></MenuItem>
                                }
                            </SubMenu>
                        }
                        {isUserAdmin &&
                            <MenuItem icon={<PeopleIcon />}><Link to="/users">User Management</Link></MenuItem>
                        }
                        {currentUser?.roles.some(x => x === Roles.WelcomeBoard) &&
                            <SubMenu title="Welcome Board" icon={<AssignmentIndIcon />}>
                                <MenuItem icon={<SettingsIcon />}><Link to="/welcome-board">Settings</Link></MenuItem>
                                <MenuItem icon={<ViewQuiltIcon />}><Link to="/welcome-board/layout">Layout</Link></MenuItem>
                            </SubMenu>
                        }
                        {/* <SubMenu title="Settings" icon={<SettingsIcon />}>
                            <MenuItem>User Settings</MenuItem>
                            <MenuItem>Organization Settings</MenuItem>
                        </SubMenu> */}
                    </AuthenticatedTemplate>
                </Menu>
            </SidebarContent>
            <SidebarFooter>
                <AuthenticatedTemplate>
                    <p style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }} title={currentUser?.username}>{currentUser?.username}</p>
                    <Button color="inverted" variant="contained"
                        onClick={() => instance.logoutRedirect({ postLogoutRedirectUri: "/" })}
                        startIcon={<LogoutIcon />}>{isCollapsed ? '' : 'Sign out'}
                    </Button>
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                    <Button color="inverted" variant="contained"
                        onClick={() => instance.loginRedirect()}
                        startIcon={<LoginIcon />}>{isCollapsed ? '' : 'Sign in'}
                    </Button>
                </UnauthenticatedTemplate>
            </SidebarFooter>
        </ProSidebar>
    );
}